import server from './http'

const checkResponse = (request) => request.then(res => {
    if (res && Number(res.code) === 500) {
        throw new Error(res.msg || '请求失败')
    }
    return res
})

const employmentApi = {
    departmentTree: (param) => checkResponse(server.post('/configure/departmentTree', param)),
    addDepartment: (param) => checkResponse(server.post('/configure/addDepartment', param)),
    editDepartment: (param) => checkResponse(server.post('/configure/editDepartment', param)),
    deleteDepartment: (param) => checkResponse(server.post('/configure/deleteDepartment', param)),

    getRoleList: (param) => checkResponse(server.post('/configure/getRoleList', param)),
    addRole: (param) => checkResponse(server.post('/configure/addRole', param)),
    editRole: (param) => checkResponse(server.post('/configure/editRole', param)),
    getRoleDetail: (param) => checkResponse(server.post('/configure/getRole', param)),
    deleteRole: (param) => checkResponse(server.post('/configure/deleteRole', param)),
    allDepartmentTree: (param) => checkResponse(server.post('/configure/allDepartmentTree', param)),
    getMenuList: (param) => checkResponse(server.post('/configure/menuList', param)),
    toggleRole: (param) => checkResponse(server.post('/configure/toggleRole', param)),

    getStaffList: (param) => checkResponse(server.post('/configure/staffList', param)),
    addStaff: (param) => checkResponse(server.post('/configure/addStaff', param)),
    editStaff: (param) => checkResponse(server.post('/configure/editStaff', param)),
    deleteStaff: (param) => checkResponse(server.post('/configure/deleteStaff', param)),
    toggleStaff: (param) => checkResponse(server.post('/configure/toggleStaff', param)),
    clearPassword: (param) => checkResponse(server.post('/configure/clearPassword', param)),
    selectRole: (param) => checkResponse(server.post('/configure/selectRole', param)),
    getDepartmentListByRoleId: (param) => checkResponse(server.post('/configure/getDepartmentListByRoleId', param)),

    getCompanyInfo: (param) => checkResponse(server.post('/configure/getCompanyInfo', param)),


    // 服务商主体
    configServiceList: (param) => checkResponse(server.post('/configure/getProjectList', param)),  // 服务商主体列表
    configHumanServiceList: (param) => checkResponse(server.post('/configure/serviceList', param)), // 人力资源用工主体列表
    getHrServiceList: (param) => checkResponse(server.post('/configure/getHrServiceList', param)), // 人力服务商主体列表
    configAddService: (param) => checkResponse(server.post('/configure/addService', param)),  // 新增主体
    toggleContractMain: (param) => checkResponse(server.post('/configure/toggleContractMain', param)), // 更换签约主体
    changeHrService: (param) => checkResponse(server.post('/configure/changeHrService', param)), // 更换人力资源用工主体
    syncYjtData: (param) => checkResponse(server.post('/configure/syncYjtData', param)), // 同步易匠通数据
    changeService: (param) => checkResponse(server.post('/configure/changeService', param)), // 更换主体
    changeServiceStatus: (param) => checkResponse(server.post('/configure/changeService', param)), // 更换主体
    addProjectContractMain: (param) => checkResponse(server.post('/configure/addProjectContractMain', param)), // 新增客户主体
    getServiceListYjt: (param) => checkResponse(server.post('/configure/getServiceList', param)), // 获取灵工、商户可选主体

    setIndexDatumShowStatus: (param) => checkResponse(server.post('/portal/setIndexDatumShowStatus', param)), // 设置首页用工数据是否显示
    accountRecords: (param) => checkResponse(server.post ('/manpower/user/accountRecords', param)), // 账户列表

    // 权益卡
    superVipInfo: (param) => checkResponse(server.post ('/portal/superVipInfo', param)), // 权益卡信息
    buySuperVip: (param) => checkResponse(server.post ('/portal/buySuperVip', param)), // 购买权益卡
    querySuperVipPayStatus: (param) => checkResponse(server.post ('/portal/querySuperVipPayStatus', param)), // 权益卡支付状态查询
}

export default employmentApi
